export enum EBeep {
  ERROR = 'error-sound.wav',
}